// extracted by mini-css-extract-plugin
export default {"RevertIdentity":"RevertIdentity_RevertIdentity__CsqQq"};